import cookies from 'js-cookie';
import { get } from 'lodash';
import { AnalyticsTypes } from '@zocdoc-frontend-common/utils-react/google-analytics';
import { logEvent } from '../../Booking/utils';
import { BusinessUnit } from '../../constants';
import { ContentGroupKeys } from '../../middleware/google-analytics';
import { getAnalyticsMeta } from './getMeta';

const getContentGroupName = (contentGroup) => {
    return (
        Object.keys(ContentGroupKeys).find(
            (key) => ContentGroupKeys[key] === contentGroup
        ) || null
    );
};

const getInsuranceCookies = () => ({
    InsuranceCarrierDental: cookies.get('dCarrierId') || null,
    InsuranceCarrierHealth: cookies.get('hCarrierId') || null,
    InsuranceCarrierVision: cookies.get('vCarrierId') || null,
    InsurancePlanDental: cookies.get('dPlanId') || null,
    InsurancePlanHealth: cookies.get('hPlanId') || null,
    InsurancePlanVision: cookies.get('vPlanId') || null,
});

const getPreviousUrl = () => {
    if (typeof document !== 'undefined') {
        return document.referrer;
    }
};

const getCurrentUrl = () => {
    if (typeof window !== 'undefined') {
        return window.location.href;
    }
};

const makeEvent = (
    analytics,
    pageName,
    title,
    pageType,
    rollupBucket,
    pathName
) => {
    switch (analytics.type) {
        case AnalyticsTypes.ChangePageView:
            return {
                type: 'Pageview',
                businessUnit: BusinessUnit.PATIENT_WEB_APP,
                version: '2.1.0',
                data: {
                    Name: title,
                    Category: pageName,
                    Page: pageName,
                    IsWhiteLabel: false,
                    PreviousUrl: getPreviousUrl(),
                    CurrentUrl: getCurrentUrl(),
                    Experiments: null,
                    Path: pathName,
                    ZlogPageType: pageType,
                    ZlogRollupBucket: rollupBucket,
                    ...getInsuranceCookies(),
                },
            };
        case AnalyticsTypes.TrackEvent:
            return {
                type: 'Action',
                version: '2.1.0',
                data: {
                    Action: analytics.action,
                    Name: `[${pageName}] ${analytics.action}`,
                    Category: pageName,
                    ZlogPageType: pageType,
                    ZlogRollupBucket: rollupBucket,
                    Page: pageName,
                },

                businessUnit: BusinessUnit.PATIENT_WEB_APP,
            };
        case 2: // set dimensions
            return {
                type: 'Set content group',
                version: '2.1.0',
                businessUnit: BusinessUnit.GA_EVENT,
                data: {
                    Name: getContentGroupName(analytics.index),
                    Value: analytics.value,
                },
            };
        default:
            return;
    }
};

export const eventsLogger = (store) => (next) => (action) => {
    let analytics = action?.meta?.analytics;

    if (analytics) {
        const state = store.getState();
        const pathname =
            get(state, 'routing.locationBeforeTransitions.pathname') ||
            window.location.pathname;

        const [pageName, title, pageType, rollupBucket] =
            getAnalyticsMeta(pathname);

        if (pageName) {
            analytics = [action.meta.analytics];
            if (Array.isArray(action.meta.analytics)) {
                analytics = action.meta.analytics;
            }

            analytics.forEach((entry) => {
                const event = makeEvent(
                    entry,
                    pageName,
                    title,
                    pageType,
                    rollupBucket,
                    pathname
                );
                logEvent({
                    event,
                    businessUnit: event.businessUnit,
                    includeBookingId: false,
                });
            });
            return;
        }
    }
    return next(action);
};
